import React, { type ReactNode } from "react";
import { useGetVehicleByIdQuery } from "../../redux/checklistStoreAPI";
import { toast } from "react-toastify";
import { AVehicle } from "../../types/vehicle";
import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { adjustDateByTime } from "../../assets/usefulFunctions";

export type TDetailMap = {
  label: string;
  value: ReactNode;
};

const useVehicleDetails = (
  internal_id?: string
): [
  {
    detailVehicleMap: TDetailMap[];
    detailSpecMap: TDetailMap[];
    detailOwnedMap: TDetailMap[];
    detailRentMap: TDetailMap[];
    detailUserMap: TDetailMap[];
  },
  "active" | "inactive",
  AVehicle | undefined,
  boolean,
  FetchBaseQueryError | SerializedError | undefined
] => {
  const {
    currentData: d,
    isLoading,
    isFetching,
    error,
  } = useGetVehicleByIdQuery(internal_id ?? "", {
    skip: !internal_id,
  });
  const loading = isLoading || isFetching;
  // const [status] = React.useState<"active" | "inactive">("inactive");
  const status: "active" | "inactive" =
    d?.status === "ACTIVE" ? "active" : "inactive";

  React.useEffect(() => {
    if (error) {
      let message = "Unknown error";
      if ("message" in error) {
        message = error.message ?? message;
      }
      toast.error(`Gagal memuat kendaraan: ${message}`);
    }
  }, [error]);
  const data = React.useMemo(() => {
    const detailVehicleMap: TDetailMap[] = [
      {
        label: "Jenis Kendaraan",
        value: `${d?.type} - ${d?.sub_type}` ?? "-",
      },
      {
        label: "Internal ID",
        value: d?.internal_id ?? "-",
      },
      {
        label: "Register ID",
        value: d?.register_id ?? "-",
      },
      {
        label: "Vehicle ID",
        value: d?.vehicle_id ?? "-",
      },
    ];
    const detailSpecMap: TDetailMap[] = [
      {
        label: "Merk",
        value: d?.brand ?? "-",
      },
      {
        label: "Kapasitas",
        value: d?.capacity ?? "-",
      },
      {
        label: "Power",
        value: d?.power ?? "-",
      },
    ];
    const detailOwnedMap: TDetailMap[] = [
      {
        label: "SAP Code",
        value: d?.sap_code ?? "-",
      },
      {
        label: "Tahun",
        value: d?.year ?? "-",
      },
    ];

    const detailRentMap: TDetailMap[] = [
      {
        label: "Jangka Waktu",
        value: d?.rent_term ?? "-",
      },
      {
        label: "Mulai",
        value: d?.rent_start_date
          ? adjustDateByTime(d?.rent_start_date, "dd MMM yyyy")
          : "-",
      },
      {
        label: "Selesai",
        value: d?.rent_finish_date
          ? // ? format(new Date(d.rent_finish_date), "dd MMM yyyy", { locale: id })
            adjustDateByTime(d?.rent_finish_date, "dd MMM yyyy")
          : "-",
      },
      {
        label: "Vendor",
        value: d?.vendor ?? "-",
      },
      {
        label: "Tahun Kendaraan",
        value: d?.rent_year ? new Date(d?.rent_year).getFullYear() : "-",
      },
      {
        label: "Operator",
        value: d?.operator ?? "-",
      },
    ];
    const detailUserMap: TDetailMap[] = [
      {
        label: "Dept",
        value: `${d?.dept} - ${d?.sub_dept}` ?? "-",
      },
    ];

    return {
      detailVehicleMap,
      detailSpecMap,
      detailOwnedMap,
      detailRentMap,
      detailUserMap,
    };
  }, [d]);

  return [data, status, d, loading, error];
};

export default useVehicleDetails;
